import type { LegacyHandlers } from '../legacy-mirrored-builder';

type FieldHandlers = Pick<LegacyHandlers, 'createField' | 'updateField' | 'deleteField' | 'reorderField'>;

// TODO: implement as fields move to the new model. Mirror the mapping used in
// identify-submitter.ts (findField/set_isRequired/etc.) for the legacy ExoWeb writes.
export const createLegacyFieldHandlers = (): FieldHandlers => ({});
